import React from "react";

const ALCANCE_LABEL = { diario: "Diario", cierre: "Cierre de mes", historico: "Histórico (pruebas)" };
const ALCANCE_CLS = {
  diario: "bg-sky-50 text-sky-800 border-sky-200",
  cierre: "bg-violet-50 text-violet-800 border-violet-200",
  historico: "bg-slate-100 text-slate-600 border-slate-200",
};

export const AlcanceBadge = ({ alcance, testId }) => (
  <span className={`text-[10px] px-1.5 py-0.5 rounded border ${ALCANCE_CLS[alcance] || ALCANCE_CLS.historico}`} data-testid={testId}>
    {ALCANCE_LABEL[alcance] || alcance || "Histórico (pruebas)"}
  </span>
);

const fmtMoney = (v) => (v == null ? "—" : Number(v).toLocaleString("es-CO", { minimumFractionDigits: 2 }));

/** Lista de paquetes de una corrida (diario / cierre) con rango, nombre, tamaño y sha. */
export const TsolPaquetes = ({ paquetes, testId = "tsol-paquetes", compact = false }) => {
  if (!Array.isArray(paquetes) || paquetes.length === 0) return null;
  return (
    <ul className={`space-y-0.5 ${compact ? "text-[11px]" : "text-xs"}`} data-testid={testId}>
      {paquetes.map((p, i) => {
        const ok = p.ok || p.status === "enviado" || p.status === "ya_enviado" || p.enviado;
        const statusTxt = p.status || (p.enviado ? "enviado" : "pendiente");
        return (
          <li key={`${p.alcance}-${p.zip_name}-${i}`} className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-testid={`${testId}-${p.alcance}`}>
            <AlcanceBadge alcance={p.alcance} />
            <span>{p.date_from} → {p.date_to}</span>
            <span>· <b>{p.zip_name}</b></span>
            {p.size_bytes != null && <span>· {p.size_bytes} B</span>}
            {p.sha256 && <span>· sha <code>{String(p.sha256).slice(0, 10)}…</code></span>}
            {p.lineas != null && <span>· {p.lineas} líneas</span>}
            {p.totales_control != null && <span>· total {fmtMoney(p.totales_control)}</span>}
            <span className={ok ? "text-emerald-700 font-medium" : statusTxt === "pendiente" ? "text-amber-700" : "text-red-700 font-medium"}>
              · {statusTxt}{p.failed_step ? ` (${p.failed_step})` : ""}
            </span>
            {p.error && !ok && <span className="text-red-700">· {p.error}</span>}
          </li>
        );
      })}
    </ul>
  );
};
